// extracted by mini-css-extract-plugin
export default {"control":"control_control__xHWDc","button":"control_button__InzL1"};